import { useSelector } from 'react-redux'
import { Box, Button, Drawer } from '@mui/material'
import { useEffect, useState, useRef, ReactElement } from 'react'
import useSound from 'use-sound'
import Badge from '@mui/material/Badge'
import NotificationItem from './NotificationItem'
import NotificationsIcon from '@mui/icons-material/Notifications'
import alertSound from '../../../assets/AlertSound/alertSound.mp3'
import './ThopNotifications.css'

const ThopNotifications = (): ReactElement => {
  const [play] = useSound(alertSound, { volume: 0.2 })

  const notificationMessages = useSelector(
    (state: any) => state?.thopNotificationMessages
  )

  const [drawerOpen, setDrawerOpen] = useState<boolean>(false)
  const [unreadCount, setUnreadCount] = useState(notificationMessages?.length)
  const prevNotificationLength = useRef(notificationMessages?.length)

  const handleNotificationClick = () => {
    setDrawerOpen(true)
  }

  useEffect(() => {
    if (notificationMessages?.length > prevNotificationLength?.current) {
      play()
    }
    prevNotificationLength.current = notificationMessages?.length

    setUnreadCount(notificationMessages?.length)
  }, [notificationMessages, play])

  return (
    <Box
      marginY={3}
      display='flex'
      paddingX='20px'
      justifyContent='center'
      id='thop-notifications'
    >
      {notificationMessages?.length > 0 && (
        <Button
          disableElevation
          variant='contained'
          aria-haspopup='true'
          id='thop-alert-button'
          className='alert-button'
          aria-label='show notifications'
          onClick={handleNotificationClick}
          aria-expanded={drawerOpen ? 'true' : undefined}
          aria-controls={drawerOpen ? 'alerts-menu' : undefined}
        >
          <Badge color='success' badgeContent={unreadCount}>
            <NotificationsIcon fontSize='medium' />
          </Badge>
        </Button>
      )}
      <Drawer
        anchor='right'
        id='alert-drawer'
        open={drawerOpen}
        className='alertDrawer'
        onClose={() => setDrawerOpen(false)}
      >
        <NotificationItem setOpen={setDrawerOpen} />
      </Drawer>
    </Box>
  )
}

export default ThopNotifications
